/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import onImageFallback from "utils/onImageFallback";

import { useEnvs } from "state/EnvironmentsContext/EnvContext";

const Image = ({ ...args }: any) => {
  const { placeholder, placeholder_small, placeholder_large } = useEnvs();

  let DEFAULT_PLACEHOLDER = placeholder;

  switch (args.size) {
    case "sm":
      DEFAULT_PLACEHOLDER = placeholder_small;
      break;
    case "md":
      DEFAULT_PLACEHOLDER = placeholder;
      break;
    case "lg":
      DEFAULT_PLACEHOLDER = placeholder_large;
      break;
  }

  return (
    <img
      {...args}
      src={args.src || DEFAULT_PLACEHOLDER}
      alt={args.alt || "image"}
      onError={(e) => {
        if (args.onError) args.onError(e);
        onImageFallback(e);
      }}
      test-id="2wMzXrDL"
    />
  );
};

export default Image;
